import { messages } from './ReportsListToolbar.messages';
import { ReportListSorting } from './ReportsListToolbar.types';

export const sortingOptions = [
    {
        id: ReportListSorting.ReportName,
        name: messages.sortByReportNameText,
    },
    {
        id: ReportListSorting.ExecutionDate,
        name: messages.sortByRecentText,
    },
    {
        id: ReportListSorting.CreationDate,
        name: messages.sortByCreationDateText,
    },
];
